import axios from "axios";
import { BASE_URL } from "./config";
import TokenService from "./services/auth/TokenService";

const http = axios.create({
  // baseURL: "http://localhost:5001",
  baseURL: BASE_URL,
  headers: {
    "Allow-Control-Allow-Origin": "*",
    "Content-type": "application/json",
  },
});
const httpUnAuthenicated = axios.create({
  // baseURL: "http://localhost:5000",
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});
http.interceptors.request.use(
  async (config) => {
    const token = TokenService.getLocalAccessToken();
    // console.log("🚀 ~ token:", token);
    const checkedToken = await handleJWT(token);
    // console.log("🚀 ~ checkedToken:", checkedToken)

    if (checkedToken) {
      config.headers["Authorization"] = "Bearer " + checkedToken; // Updated with checkedToken
    }
    return config;
  },
  (error) => {
    // window.location.href = "/login";

    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (
      originalConfig &&
      originalConfig.url !== "/api/auth/signin" &&
      err.response
    ) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        console.log("access token expired");
        window.location.href = "/#/login";
        originalConfig._retry = true;
      }
    }

    return Promise.reject(err);
  }
);

export default http;

async function handleJWT(token) {
  if (!token) {
    return null;
  }

  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  const parsedToken = JSON.parse(jsonPayload);
  // console.log("🚀 ~ handleJWT ~ parsedToken:", parsedToken);

  if (!parsedToken) {
    return token;
  }

  const expDate = parsedToken.exp * 1000;

  if (expDate <= new Date().getTime()) {
    try {
      const rs = await httpUnAuthenicated.post("/api/auth/refreshtoken", {
        refreshToken: TokenService.getLocalRefreshToken(),
      });
      // console.log("🚀 ~ handleJWT ~ rs:", rs);
      const { accessToken, refreshToken } = rs.data;
      TokenService.updateLocalAccessToken(accessToken);
      TokenService.updateRefreshToken(refreshToken);

      return accessToken;
    } catch (error) {
      console.log("🚀 ~ handleJWT ~ error:", error);
      window.location.href = "/#/login";
      throw error;
    }
  }

  return token;
}
